export default __webpack_public_path__ + "static/media/cat_mulvihill.37d8abd9.png";